import axios from '@/app/axios'
import CrudService from '@/common/services/crud-service'
import User from '@/users/entities/user'
import Responses from '@/app/utils/responses'

class UsersService extends CrudService<User> {
}

export default new UsersService('users')
